<!-- Form -->
@if (descriptionForm) {
  <medsurf-design-form-control-form
    [formGroup]="descriptionForm"
    className="h-full"
    (onSubmit)="onSubmit()">
    <!-- Editor -->
    <medsurf-editor [formField]="false"
      [control]="descriptionForm.controls.description"
      placeholder="global.description"
      class="h-full"
      [fullHeight]="true"
      [autogrow]="false"
      [toolbarExcludes]="['marker']"
    (valueChange)="onSubmit()"></medsurf-editor>
  </medsurf-design-form-control-form>
}
